export const findOne = (haystack, arr) => {
    return arr.some(function (v) {
        return haystack.indexOf(v) >= 0;
    });
};


/** WEBPACK FOOTER **
 ** ./src/actions/permissions.js
 **/